import { useSelector, useDispatch } from 'react-redux';
import { useCallback } from 'react';
import {
  loginUser,
  registerUser,
   clearError,
  setCredentials,
  clearAuth,
  selectAuth,
  selectIsAuthenticated,
  selectUserRole,
  selectToken,
  selectCurrentUser,
  selectAuthLoading,
  selectAuthError,
  selectSubscription,
  selectOwner,
  logoutUser,
} from '@/stores/slice/authSlice';

export const useAuth = () => {
  const dispatch = useDispatch();

  // Get full auth state first
  const auth = useSelector(selectAuth);

  // Core auth state - always call these hooks
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const role = useSelector(selectUserRole);
  const token = useSelector(selectToken);
  const user = useSelector(selectCurrentUser);
  const isLoading = useSelector(selectAuthLoading);
  const error = useSelector(selectAuthError);
  const subscription = useSelector(selectSubscription);
  const owner = useSelector(selectOwner);

  // Core actions - always define these
  const login = useCallback((credentials) => {
    return dispatch(loginUser(credentials));
  }, [dispatch]);

  const register = useCallback((registrationData) => {
    return dispatch(registerUser(registrationData));
  }, [dispatch]);

  const logout = useCallback(() => {

    return dispatch(logoutUser());
  }, [dispatch]);

  const clearAuthError = useCallback(() => {
    dispatch(clearError());
  }, [dispatch]);

  const setUserCredentials = useCallback((credentials) => {
    dispatch(setCredentials(credentials));
  }, [dispatch]);

  const clearAuthData = useCallback(() => {
    dispatch(clearAuth());
  }, [dispatch]);

  // Role checks - always define these
  const isUser = useCallback(() => {
    return role === 'USER';
  }, [role]);

  const isOwner = useCallback(() => {
    return role === 'OWNER';
  }, [role]);

  const isAdmin = useCallback(() => {
    return role === 'ADMIN';
  }, [role]);

  const hasSubscriptionAccess = useCallback(() => {
    return role === 'USER' || role === 'OWNER';
  }, [role]);

  // Always return the same object structure
  return {
    // Core state
    auth,
    isAuthenticated,
    role,
    token,
    user,
    isLoading,
    error,
    subscription,
    owner,

    // Core actions
    login,
    register,
    logout,
    clearAuthError,
    setUserCredentials,
    clearAuthData,

    // Role checks
    isUser,
    isOwner,
    isAdmin,
    hasSubscriptionAccess,
  };
};